import React, { useEffect } from 'react'
import { useSelector } from 'react-redux'
import { getUserData, updateWindowDimensions } from '../redux/app/actions'
import { useInternationalization } from '../hooks/Internationalization'
import BuildingPicker from '../components/BuildingPicker'
import Error from './Error'
import Guardian from './Guardian'
import Loading from '../components/Loading'
import Shield from './Shield'
import getAppInfo from '../lib/getAppInfo'
import useInit from '../hooks/useInit'
import { useCreateOccupancy } from '../hooks/useCreateOccupancy'

function AppSwitch({ authState }) {
    const isLoading = useSelector((state) => state.app.isLoading)
    const showBuildingPicker = useSelector((state) => state.app.showBuildingPicker)
    const showErrorPage = useSelector((state) => state.app.showErrorPage)

    const createNewOccupancy = useSelector(state => state.auth.createNewOccupancy)

    const updateDimensions = () => {
        updateWindowDimensions(window.innerWidth, window.innerHeight)
    }

    useInternationalization()
    useCreateOccupancy()
    //useInit()

    useEffect(() => {

        if (authState === 'signedIn') {
            getUserData()
        }
        updateDimensions()
        // window.addEventListener('resize', updateDimensions)
        // return () => window.removeEventListener('resize', updateDimensions)
    }, [authState])

    if (authState !== 'signedIn') return null
    if (showErrorPage) return <Error />
    
    if (createNewOccupancy) return <Loading />
    if (showBuildingPicker) return <BuildingPicker />

    if (isLoading) return <Loading />
    const app = getAppInfo()
    if (app.isShield) return <Shield />
    return <Guardian />
}

export default AppSwitch
